import { configureAnalytics, type AnalyticsAdapter, type AnalyticsInteraction } from '../../lib/analytics'
import { breakupAnalytics, isBreakupAnalytics } from '../../features/breakup-analytics'
import * as metrica from '../../lib/metrica'

const BREAKUP_GOALS = {
  quizStarted: 'quiz_start',
  quizCompleted: 'quiz_complete',
  messageAccepted: 'chat_message_sent',
  sosClicked: 'sos_click',
  journeyViewed: 'path_view',
  pricingViewed: 'paywall_view',
  tasksViewed: 'tasks_view',
} satisfies Record<Exclude<AnalyticsInteraction, 'onboardingStarted' | 'onboardingStepViewed' | 'onboardingCompleted' | 'paymentOpened'>, Parameters<typeof breakupAnalytics.goal>[0]>

const adapter: AnalyticsAdapter = {
  track(...event) {
    switch (event[0]) {
      case 'onboardingStarted':
        return breakupAnalytics.goal('onboarding_start', { onboarding_variant: event[1].variant })
      case 'onboardingStepViewed': {
        const { variant, step } = event[1]
        breakupAnalytics.screen(`/onboarding/${variant === 'quiz' ? 'quiz' : 'no-quiz'}/step-${step}`)
        return breakupAnalytics.goal('onboarding_step_view', { onboarding_variant: variant, onboarding_step: step })
      }
      case 'onboardingCompleted':
        return breakupAnalytics.goal('onboarding_complete', { onboarding_variant: event[1].variant })
      case 'paymentOpened': {
        const tariff = event[1].planId
        if (tariff !== 'week' && tariff !== 'month' && tariff !== 'program') return false
        return breakupAnalytics.goal('payment_open', { tariff })
      }
      default:
        return breakupAnalytics.goal(BREAKUP_GOALS[event[0]])
    }
  },
  screen(path, product) {
    // Product routing belongs here, not in the counter or shared shell.
    if (product !== 'break_up' || path === '/next-step') return
    if (breakupAnalytics.screen(path) && path === '/') {
      breakupAnalytics.goal('home_view')
      breakupAnalytics.goal('chat_open')
    }
  },
  paywallViewed(reason) {
    // BreakUp counts the rendered tariff catalog; Humanteq/native retain their modal goal.
    if (!isBreakupAnalytics()) metrica.reachGoal('paywall_view', { reason })
  },
}

export function initializeAppAnalytics(): void {
  configureAnalytics(adapter)
  breakupAnalytics.captureEntry()
}

export function openAppVisit(): void {
  breakupAnalytics.open()
}
